import type { JSX } from 'react';
import { NumericFormat } from 'react-number-format';
import { DrawApi } from '@apply/api';
import { formatCurrencyConditional } from '../../totalItems/constants/constants';

interface IEquityRemainingProps {
    drawBudget?: DrawApi.IDrawBudget;
    equityAmount: number;
    isAdmin: boolean;
}

export const EquityRemaining = ({ drawBudget, equityAmount, isAdmin }: IEquityRemainingProps): JSX.Element => {
    const remaining = Math.max((drawBudget?.equityRequirement ?? 0) - (equityAmount ?? 0), 0);
    const hasDecimals = remaining % 1 !== 0;

    return (
        <div>
            {isAdmin ? (
                <>
                    <label htmlFor='equityRemaining'>Equity Req. Remaining</label>
                    <NumericFormat
                        className='draw-header-input'
                        value={remaining}
                        placeholder={'$ 0'}
                        thousandSeparator={true}
                        prefix={'$ '}
                        readOnly={true}
                        disabled={true}
                        decimalScale={hasDecimals ? 2 : 0}
                        fixedDecimalScale={hasDecimals ? true : false}
                        allowNegative={false}
                        decimalSeparator='.'
                    />
                </>
            ) : (
                <>
                    <div style={{ fontSize: '11px', fontWeight: 'normal' }}>ER Remaining:</div>
                    <div>{remaining ? formatCurrencyConditional(remaining) : '-'}</div>
                </>
            )}
        </div>
    );
};
